export enum FlagsAction {
LOAD_FLAGS = 'LOAD_FLAGS',
SET_LIVE_FETCH_FLAG = 'SET_LIVE_FETCH_FLAG',
SET_PAST_FETCH_FLAG = 'SET_PAST_FETCH_FLAG',
SET_SCHEDULE_FETCH_FLAG = 'SET_SCHEDULE_FETCH_FLAG',
SET_DATAOPS_FETCH_FLAG = 'SET_DATAOPS_FETCH_FLAG',
SET_DATAOPS_ENTITIES_FETCH_FLAG = 'SET_DATAOPS_ENTITIES_FETCH_FLAG',
SET_PRACICE_SAVED_SUCCESSFULLY_FLAG = 'SET_PRACICE_SAVED_SUCCESSFULLY_FLAG',
SET_ACTION_SUCCESSFULLY_STARTED =  'SET_ACTION_SUCCESSFULLY_STARTED',
DOWNLOADING_FLAG = 'DOWNLOADING_FLAG',
CREATE_AND_GO_FLAG = 'CREATE_AND_GO_FLAG',
PLAYS_IGNORE_SAVED_FLAG = 'PLAYS_IGNORE_SAVED_FLAG',
GAME_REPROCESS_FLAG = 'GAME_REPROCESS_FLAG'
}

interface LoadFlagsAction {
  type: FlagsAction.LOAD_FLAGS;
}
export interface SetLiveFetchFlagAction {
  
    type: FlagsAction.SET_LIVE_FETCH_FLAG,
    liveFetch: boolean
  
};

export interface SetPastFetchFlagAction {
  
    type: FlagsAction.SET_PAST_FETCH_FLAG,
    pastFetch: boolean
  
};

export interface SetScheduleFetchFlagAction {
  
    type: FlagsAction.SET_SCHEDULE_FETCH_FLAG,
    scheduleFetch: boolean
  
};

export interface SetDataOpsFetchFlagAction {
  
    type: FlagsAction.SET_DATAOPS_FETCH_FLAG,
    dataOpsFetch: boolean
  
};

export interface SetPracticeSavedSuccessfullyFlagAction {
  
    type: FlagsAction.SET_PRACICE_SAVED_SUCCESSFULLY_FLAG,
    practiceSaved: boolean
  
};

export interface SetActionSuccessFlagAction {
  
    type: FlagsAction.SET_ACTION_SUCCESSFULLY_STARTED,
    actionMessage: string | null,
    actionSucceeded: boolean | null
  
};

export interface SetFileIsDownloadingAction {
 
    type: FlagsAction.DOWNLOADING_FLAG,
    download: boolean,
  
};

export interface SetCreateAndGoPracticeFlagAction {
 
    type: FlagsAction.CREATE_AND_GO_FLAG,
    createAndGoFlag: boolean,
  
};

export interface SetPlaysIgnoreSavedFlagAction {
 
    type: FlagsAction.PLAYS_IGNORE_SAVED_FLAG,
    playsSavedFlag: boolean,
  
};

export interface SetGameReprocessFlagAction {
 
    type: FlagsAction.GAME_REPROCESS_FLAG,
    reprocessFlag: boolean | string,
  
};

export interface FlagsState {
  liveFetch: boolean;
  pastFetch?: boolean;
  scheduleFetch: boolean
  dataOpsFetch: boolean 
  practiceSaved?: boolean
  actionMessage?: string,
  actionSucceeded?: boolean
  download: boolean,
  createAndGoFlag?: boolean,
  playsSavedFlag?: boolean,
  reprocessFlag?: string
}

export type FlagsActions =
  | LoadFlagsAction
  | SetLiveFetchFlagAction
  | SetPastFetchFlagAction
  | SetScheduleFetchFlagAction
  | SetDataOpsFetchFlagAction
  | SetPracticeSavedSuccessfullyFlagAction
  | SetActionSuccessFlagAction
  | SetFileIsDownloadingAction
  | SetCreateAndGoPracticeFlagAction
  | SetPlaysIgnoreSavedFlagAction
  | SetGameReprocessFlagAction